module.exports = __webpack_public_path__ + "img/Group 690four.262291b7.png";